(() => {
try {
    const getCookie = (key)=>{
        const filtered = document.cookie.split(";").map((x)=>x.split("=")).filter((x)=>x[0].replace(/ /, "") === key);
        return !filtered.length ? null : decodeURIComponent(filtered[0][1]);
    };
    const postEvent = (testPatternId, url, eventType, clickId)=>{
        const requestUrl = new URL(String("https://hlsmnyijsghjmafdkrjy.supabase.co/functions/v1/event"));
        fetch(requestUrl, {
            method: "POST",
            mode: "cors",
            headers: {
                "Authorization": `Bearer ${"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imhsc21ueWlqc2doam1hZmRrcmp5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTUzNjIwNTAsImV4cCI6MjAxMDkzODA1MH0.ytpTOvqynmpZtlaKY91pALpk-8vPrA-AlpjPaYtF3uY"}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                "test_pattern_id": testPatternId,
                "url": url,
                "event_type": eventType,
                "click_id": clickId
            })
        });
    };
    const testId = getCookie("beastt:test_id");
    if (!testId) throw new Error("test_id is undefined");
    const testPatternId = getCookie("beastt:test_pattern_id");
    if (!testPatternId) throw new Error("test_pattern_id is undefined");
    postEvent(testPatternId, location.href, "screen_view", null);
    const nodeList = document.querySelectorAll("[data-beastt-click-id]");
    nodeList.forEach((node)=>{
        const clickId = node.getAttribute("data-beastt-click-id") || "undefined";
        node.addEventListener("click", ()=>{
            postEvent(testPatternId, location.href, "click", clickId);
        });
    });
} catch (e) {
    console.log(`Beastt: monitor does not work because ${e}`);
// Do nothing
}

})();
//# sourceMappingURL=monitor.js.map
